import { render } from "./FormPhotoCrash.vue?vue&type=template&id=5e72d078"
import script from "./FormPhotoCrash.vue?vue&type=script&lang=js"
export * from "./FormPhotoCrash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__